import { render } from "./InvoiceEdit.vue?vue&type=template&id=3d95b7de&scoped=true"
import script from "./InvoiceEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceEdit.vue?vue&type=script&lang=js"

import "./InvoiceEdit.vue?vue&type=style&index=0&id=3d95b7de&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d95b7de"]])

export default __exports__